import {Component, Input, ViewChild} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";
import {ChatChannel, FileStore, FsFile, FsFileUploadRequest} from "core-lib";
import {FileUpload} from "primeng/fileupload";
import {DynamicDialogConfig, DynamicDialogRef} from "primeng/dynamicdialog";
import {HttpClient, HttpEventType, HttpRequest} from "@angular/common/http";
import {MessageService, ToastMessageOptions} from "primeng/api";
import {from, Observable, of} from "rxjs";
import {map, mergeMap, toArray} from "rxjs/operators";

@Component({
    selector: 'lib-filepicker-formcontrol',
    templateUrl: './filepicker-formcontrol.component.html',
    styleUrls: ["filepicker-formcontrol.component.scss"],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            multi:true,
            useExisting: FilepickerFormcontrol
        }
    ],
    standalone: false
})
export class FilepickerFormcontrol implements ControlValueAccessor {

    //files: File[] = [];
    acceptedFileTypes: string;
    channel: ChatChannel;
    uploadComplete: boolean = false;
    @Input()
    mediaMode: boolean = true;
    @ViewChild('fileUpload') fileUpload: FileUpload = {_files:[]} as FileUpload;

    @Input()
    uploadStatus: {
        running: boolean, details: Record<string, {
            error: boolean, complete: boolean, message: string, progress: number
        }>
    } = { running: false, details: {} };

    constructor(public dialogRef: DynamicDialogRef, private dynamicDialogConfig: DynamicDialogConfig, private http: HttpClient, private messageService: MessageService) {

    }

    get files(): File[] {
        if (this.fileUpload?._files) {
            return this.fileUpload._files;
        }
        return [];
    }

    doUpload(event): void {
        const files = event.files as File[];

        // const files = event.files as File[];
        // const fsFileUploadRequests = files.map((file) => {
        //     const request = {} as FsFileUploadRequest;
        //     request.contentLength = file.size;
        //     request.name = file.name;
        //     request.contentType = file.type;
        //     return { file, request };
        // });
        //
        // this.uploadStatus.running = true;
        //
        // from(fsFileUploadRequests).pipe(
        //     mergeMap(({ file, request }) =>
        //             this.fileStoreService.createFile(this.fileStore.id, request, null).pipe(
        //                 map(mutationResult => ({ file, fsFile: mutationResult.file, error: mutationResult.error }))
        //             ),
        //         2 // Maximal 2 gleichzeitige Datei-Erstellungen
        //     ),
        //     mergeMap(({ file, fsFile, error }) => {
        //         if (error) {
        //             this.uploadStatus.details[file.name] = { progress: 100, complete: true, message: error, error: true };
        //             return of({ file, fsFile, error });
        //         }
        //
        //         const req = new HttpRequest('PUT', fsFile.uploadUrl, file, { reportProgress: true });
        //         this.uploadStatus.details[file.name] = { progress: 0, complete: false, message: null, error: null };
        //
        //         return new Observable<{ file: File, fsFile: FsFile, error?: string }>((observer) => {
        //             this.http.request(req).subscribe({
        //                 next: (event) => {
        //                     if (event.type === HttpEventType.UploadProgress) {
        //                         const percentDone = Math.round(100 * event.loaded / (event.total ?? 0));
        //                         this.uploadStatus.details[file.name].progress = percentDone;
        //                     } else if (event.type === HttpEventType.Response) {
        //                         observer.next({ file, fsFile });
        //                         observer.complete();
        //                     }
        //                 },
        //                 error: (err) => {
        //                     observer.next({ file, fsFile, error: err.message });
        //                     observer.complete();
        //                 }
        //             });
        //         });
        //     }, 2), // Maximal 2 gleichzeitige Uploads
        //     mergeMap(({ file, fsFile, error }) => {
        //         if (error) {
        //             return of({ file, fsFile, error });
        //         } else {
        //             return this.fileStoreService.fileStoreUploadComplete(this.fileStore.id, fsFile.id).pipe(
        //                 map(result => ({ file, fsFile: result.file, error: result.error }))
        //             );
        //         }
        //     }, 2), // Maximal 2 gleichzeitige "complete"-Calls
        //     toArray()
        // ).subscribe((uploadCompleteResults) => {
        //     this.uploadStatus.running = false;
        //     const errors = uploadCompleteResults.filter(r => r.error != null).length;
        //     if (errors > 0) {
        //         this.messageService.add({ severity: 'warn', summary: $localize`:@@message-file-upload.successWarn:Upload completed with ${errors} errors` } as ToastMessageOptions);
        //         setTimeout(() => {
        //             uploadCompleteResults.forEach((result) => {
        //                 if (!result.error) {
        //                     this.onRemove(result.file);
        //                 }
        //             });
        //         }, 1000);
        //     } else {
        //         const fileIds = uploadCompleteResults.map(r => r.fsFile.id);
        //         this.chatService.sendMessage(this.channel.id, { body: this.messageBody, files: fileIds }).subscribe((message) => {
        //             this.messageService.add({ severity: 'success', summary: $localize`:@@message-file-upload.ok:Message send` } as ToastMessageOptions);
        //             setTimeout(() => {
        //                 this.dialogRef.close(message);
        //             }, 1000);
        //         });
        //     }
        // });
    }

    onSendMessage(): void {
        this.fileUpload.upload();
    }
    onRemoveAll() {
        this.files.splice(0, this.files.length);
        this.uploadStatus.details = {};
    }

    isImage(file: File): boolean {
        return /^image\//.test(file.type);
    }

    getIconByContenttype(file: File): string {
        if (/^video/.test(file.type)) {
            return "file-video";
        }
        if (/^audio/.test(file.type)) {
            return "file-audio";
        }
        if (/pdf/.test(file.type)) {
            return "file-pdf";
        }
        if (/officedocument\.word/.test(file.type)) {
            return "file-lines";
        }
        if (/officedocument\.spreadsheet/.test(file.type)) {
            return "file-xls";
        }
        return "file"
    }

    onRemove(file: File) {
        this.files.splice(this.files.indexOf(file), 1);
        delete this.uploadStatus.details[file.name];
    }

    ngOnInit(): void {
        this.channel = this.dynamicDialogConfig.data.channel;
        if (this.dynamicDialogConfig.data.files) {
            setTimeout(() => {
                this.fileUpload._files = [...this.dynamicDialogConfig.data.files];
                this.fileUpload.onSelect.emit({ originalEvent: new Event('paste'), files: [], currentFiles: [...this.dynamicDialogConfig.data.files] });
            }, 200)
        }
    }
    /**
     * helpers
     * @param bytes
     * @returns
     */
    formatSize(bytes) {
        if (bytes == 0) {
            return '0 B';
        }
        let k = 1000,
            dm = 3,
            sizes = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'],
            i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    choose(event, callback) {
        callback();
    }

    fileSeletcted(){
        this.markAsTouched();
        let test = JSON.parse(JSON.stringify(this.fileUpload._files));
        console.log(test)
        this.onChange(this.fileUpload._files)
    }

    touched = false;

    disabled = false;

    onChange = (files) => {};

    onTouched = () => {};

    writeValue(files: File[]) {
        this.fileUpload['_files'] = files;
    }

    registerOnChange(onChange: any) {
        this.onChange = onChange;
    }

    registerOnTouched(onTouched: any) {
        this.onTouched = onTouched;
    }

    markAsTouched() {
        if (!this.touched) {
            this.onTouched();
            this.touched = true;
        }
    }

    setDisabledState(disabled: boolean) {
        this.disabled = disabled;
    }
}
